module.exports = __webpack_public_path__ + "img/metrics.0cd091de.svg";